export function toMeshColorsKey(colors) {
    return colors.join(',');
}
export function assertMeshPalette(colors) {
    if (colors.length !== 4) {
        throw new Error(`Mesh palette requires exactly 4 colors, got ${colors.length}`);
    }
}
